<template>
  <span
    v-b-tooltip.hover.top="{
      boundary: 'viewport',
      modifiers: {
        flip: { enabled: false }
      },
      customClass: 'whatsapp-tooltip'
    }"
    :title="`Enviar a ${tipoRotina} por WhatsApp.`"
  >
    <b-btn
      variant="none"
      class="btn-none icone-acao m-0 p-0"
      :disabled="tipoRotina === 'CND RFB/PGFN' && row.situacao === 'motivo' || disabled"
      @click="openWhatsApp()"
    >
      <font-awesome-icon
        icon="fa-brands fa-whatsapp"
        class="text-primary"
        style="font-size: 20px !important;"
      />
      <loading
        :show-cancel-button="false"
        :is-loading="isLoading"
        :titulo-carregamento="'Aguarde!'"
        :descricao="`Estamos Enviando a ${tipoRotina}.`"
      />
    </b-btn>
  </span>
</template>

<style>
.whatsapp-tooltip .tooltip-inner {
  max-width: 180px !important;
  white-space: normal;
  text-align: center;
  margin-right: 20%;
}
</style>

<script>
import moment from 'moment'

export default {
  components: {
    Loading: () => import('@pilar/components/loading/Loading.vue'),
  },
  props: {
    tipoRotina: {
      type: String,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
    api: {
      type: Object,
      required: true,
    },
    mensagem: {
      type: String,
      default: null,
    },
    isHistorico: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tipoParcelamento: {
      type: String,
      default: '',
    },
    competencia: {
      type: String,
      default: '',
    },
    empresaId: {
      type: String,
      default: '',
    },
    isMensagem: {
      type: Boolean,
      default: false,
    },
    isDownload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      mensagemlocal: this.mensagem,
      ishistorico: this.isHistorico,
    }
  },
  methods: {
    openWhatsApp() {
      this.MontarModal()
    },
    MontarModal() {
      this.isLoading = true

      const parcelaId = this.row.parcelaId || null
      const tipo = this.tipoParcelamento || null
      const competencia = this.competencia || null
      const idEnviado = this.empresaId || this.row.id || null
      let parametro = null
      if (parcelaId) {
        parametro = parcelaId
      } else if (competencia) {
        parametro = competencia
      } else {
        parametro = tipo
      }
      if (this.isMensagem) {
        this.isLoading = false
        this.mostrarModalSecundario(this.row.mensagem)
      } else {
        this.api.getDocWhatsapp(idEnviado, parametro)
          .then(payload => {
            this.isLoading = false
            this.mostrarModalPrincipal(payload.data)
          })
          .catch(err => {
            this.isLoading = false
            this.$erro(`Erro ao encaminhar mensagem via WhatsApp: ${err}.`, err)
          })
      }
    },
    buildMensagem() {
      if (this.ishistorico && this.linhasSelecionadas && this.linhasSelecionadas.length > 0) {
        this.mensagem = this.mensagem ?? `Olá ${this.row.razaoSocial} segue link para download das parcelas ${this.tipoRotina} selecionadas.\r\n\r\nApós baixar, solicitamos que faça a conferência dos dados!\r\n\r\nO link ficará disponível até ${this.getDataVencimento()} `
        return this.mensagem
      }
      this.mensagem = this.mensagem ?? `Olá ${this.row.razaoSocial} segue link para download da ${this.tipoRotina}.\r\n\r\nApós baixar, solicitamos que faça a conferência dos dados!\r\n\r\nO link ficará disponível até ${this.getDataVencimento()} `
      return this.mensagem
    },
    getDataVencimento() {
      return moment().add(15, 'days').format('DD/MM/YYYY')
    },
    getMensagemEditavel() {
      const mensagemCompleta = this.buildMensagem()
      const dataVencimento = this.getDataVencimento()
      return mensagemCompleta.replace(`O link ficará disponível até ${dataVencimento}`, '')
    },
    montarMensagemCompleta(mensagemEditavel) {
      const dataVencimento = this.getDataVencimento()
      return `${mensagemEditavel}\r\n\r\nO link ficará disponível até ${dataVencimento} `
    },
    editarMensagem(linkArquivo) {
      this.$swal({
        title: '<div class="text-secondary mb-1">Editar Mensagem</div>',
        html: `
          <div class="text-left">
            <label for="mensagem-textarea" class="form-label text-secondary">Mensagem personalizada:</label>
            <textarea 
              id="mensagem-textarea" 
              class="form-control" 
              rows="6" 
              style="resize: vertical; font-size: 14px;"
              placeholder="Digite sua mensagem personalizada..."
            >${this.getMensagemEditavel()}</textarea>
            <div class="mt-2 p-2 bg-light border rounded">
              <small class="text-muted">
                <i class="fa fa-info-circle"></i> <strong>Adicionado automaticamente pelo sistema:</strong><br>
                O link ficará disponível até <strong>${this.getDataVencimento()}</strong><br>
                + Link do arquivo
              </small>
            </div>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Salvar',
        cancelButtonText: 'Cancelar',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-primary mr-50',
          cancelButton: 'btn btn-outline-secondary mr-50',
        },
        width: 600,
        preConfirm: () => {
          const textarea = document.getElementById('mensagem-textarea')
          const novaMensagem = textarea.value.trim()

          if (!novaMensagem) {
            this.$swal.showValidationMessage('Por favor, digite uma mensagem')
            return false
          }
          return novaMensagem
        },
      }).then(result => {
        if (result.isConfirmed) {
          this.mensagem = this.montarMensagemCompleta(result.value)

          this.mostrarModalPrincipal(linkArquivo)
        }
      })
    },
    mostrarModalPrincipal(linkArquivo) {
      this.$swal({
        width: 680,
        title: '<div class="text-secondary mb-2  mt-1">Envio via WhatsApp</div>',
        html: `
          <textarea readonly class="form-control" rows="6" columns="6">${(this.buildMensagem())} 
          </textarea>
          <div style="text-align: center; margin: 15px 0;">
            <button type="button" id="btn-editar-mensagem" class="btn btn-outline-primary btn-sm">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                
                <path d="m26 -2.5 a2.5 2.5 0 0 1 0 3.5l-15 15-4 1 1-4 15-15a2.5 2.5 0 0 1 3.5 0z"></path>
              </svg>
              Editar
            </button>
          </div>
          <div class="text-primary mb-1 mt-1">
            <a href="${linkArquivo}" target="_blank" class="text-secondary" style="text-decoration: underline;">Link do arquivo</a>
          </div>
        `,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'WhatsApp',
        denyButtonText: 'Copiar link',
        cancelButtonText: 'Cancelar',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-primary mr-50',
          denyButton: 'btn btn-outline-secondary mr-50',
          cancelButton: 'btn btn-outline-danger mr-50',
          actions: 'swal2-actions-custom',
        },
        allowOutsideClick: true,
        didOpen: () => {
          const btnEditarMensagem = document.getElementById('btn-editar-mensagem')
          if (btnEditarMensagem) {
            btnEditarMensagem.addEventListener('click', () => {
              this.$swal.close()
              this.editarMensagem(linkArquivo)
            })
          }
        },
      }).then(result => {
        if (result.isConfirmed) {
          const url = `https://wa.me/?text=${encodeURIComponent(`${this.buildMensagem()}${linkArquivo}`)}`
          window.open(url)
        } else if (result.isDenied) {
          this.$swal('Copiado!', '', 'success')
          navigator.clipboard.writeText(linkArquivo)
        }
      })
    },
    mostrarModalSecundario(mensagem) {
      this.$swal({
        width: 680,
        title: '<div class="text-secondary mb-2  mt-1">Envio via WhatsApp</div>',
        html: mensagem,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'WhatsApp',
        denyButtonText: 'Copiar link',
        cancelButtonText: 'Cancelar',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-primary mr-50',
          denyButton: 'btn btn-outline-secondary mr-50',
          cancelButton: 'btn btn-outline-danger mr-50',
          actions: 'swal2-actions-custom',
        },
        allowOutsideClick: true,
        didOpen: () => {
          const btnEditarMensagem = document.getElementById('btn-editar-mensagem')
          if (btnEditarMensagem) {
            btnEditarMensagem.addEventListener('click', () => {
              this.$swal.close()
              this.editarMensagem(mensagem)
            })
          }
        },
      }).then(result => {
        if (result.isConfirmed) {
          const url = `https://wa.me/?text=${encodeURIComponent(`${this.getMensagemToHtml(mensagem)}`)}`
          window.open(url)
        } else if (result.isDenied) {
          this.$swal('Copiado!', '', 'success')
          navigator.clipboard.writeText(this.getMensagemToHtml(mensagem))
        }
      })
    },
    getMensagemToHtml(mensagem) {
      const parser = new DOMParser()
      const doc = parser.parseFromString(mensagem, 'text/html')
      return doc.body.innerText || ''
    },
  },
}
</script>
